import React from 'react';
import { CellState, Position, Idol } from 'types';

interface CellProps {
  cellState: CellState;
  position: Position;
  size: number;
  _draggedItem: Idol | null;
  _hoverPosition: Position | null;
  isHighlighted: boolean;
  isValidPlacement: boolean;
  onDragOver: (e: React.DragEvent<HTMLDivElement>, row: number, col: number) => void;
  onDragEnter: (e: React.DragEvent<HTMLDivElement>, row: number, col: number) => void;
  onDragLeave: (e: React.DragEvent<HTMLDivElement>) => void;
  onDrop: (e: React.DragEvent<HTMLDivElement>, row: number, col: number) => void;
}

const Cell: React.FC<CellProps> = ({
  cellState,
  position,
  size,
  _draggedItem,
  _hoverPosition,
  isHighlighted,
  isValidPlacement,
  onDragOver,
  onDragEnter,
  onDragLeave,
  onDrop
}) => {
  const { row, col } = position;
  const { disabled } = cellState;
  
  return (
    <div
      className={`
        w-full h-full
        ${disabled ? 'bg-gray-900' : 'bg-blue-900 bg-opacity-30'}
        ${isHighlighted ? (isValidPlacement ? 'bg-green-600 bg-opacity-40' : 'bg-red-600 bg-opacity-40') : ''}
        transition-colors duration-200
      `}
      style={{
        width: `${size}px`,
        height: `${size}px`
      }}
      onDragOver={(e) => onDragOver(e, row, col)}
      onDragEnter={disabled ? undefined : (e) => onDragEnter(e, row, col)}
      onDragLeave={disabled ? undefined : onDragLeave}
      onDrop={disabled ? undefined : (e) => onDrop(e, row, col)}
    />
  );
};

export default Cell;